import {InjectionToken} from "@angular/core";

export const INT_PORTAL_SLOT_UPDATE_POSITION_INTERVAL = new InjectionToken<number>('INT_PORTAL_SLOT_UPDATE_POSITION_INTERVAL', {
  factory() {
    return 1000;
  }
})
